module.exports = __webpack_public_path__ + "746b69f0f683ddb1e53427c137d2b220.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-semibold/opensans-semibold.ttf
// module id = ./src/styles/fonts/opensans-semibold/opensans-semibold.ttf
// module chunks = index